import styled from 'styled-components'
import * as All from '../BaseStyles'

export const SectionDiv = styled(All.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;
    margin: 8rem 0rem;
    background-color: white;
    border-radius: 1.5rem;
    padding: 2.4rem;
`

export const HeaderDiv = styled(All.Div)`
    padding-bottom: 2rem;
`

export const FormDiv = styled(All.Div)`
    padding: 2rem 0rem;
    border-top-style: solid;
    border-top-width: thin;
    border-bottom-style: solid;
    border-bottom-width: thin;
    border-color: #d7d7d7;
`

export const SectionHeader = styled(All.SectionHeader)`
    font-size: 3rem;
    margin: 0;
    padding: 0;
`

export const ApplicationRowDiv = styled(All.Div)`
    width: 100%;
    padding: 0.5rem 0rem;
    overflow: hidden;
`

export const LeftApplicationDiv = styled(All.Div)`
    width: 49.5%;
    margin: 0% 0.5% 0% 0%;
    display: inline-block;
`

export const RightApplicationDiv = styled(All.Div)`
    width: 49.5%;
    margin: 0% 0% 0% 0.5%; 
    float: right;
    display: inline-block;
`

export const FullApplicationDiv = styled(All.Div)`
    width: 100%;
    display: inline-block;
`

export const ApplicationHeader = styled.p`
    margin: 0;
    padding: 0;
    margin-bottom: 0.4rem;
    font-size: 1.6rem;
    font-weight: 450;
`

export const InputField = styled(All.InputField)`
    font-size: 1.6rem;
    height: 3rem;
    width: 100%;
`

export const LeftInputField = styled(InputField)`
    width: 49.5%;
    margin: 0% 0.5% 1% 0%;
`

export const RightInputField = styled(InputField)`
    width: 49.5%;
    margin: 0% 0% 1% 0.5%;
    float: right;
`

export const FullInputField = styled(InputField)`
    width: 100%;
    margin: 0% 0.5% 1% 0%;
`

export const BodyTextArea = styled.textarea`
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    font-size: 1.6rem;
    width: 100%;
    height: 20rem;
    resize: none;
    box-sizing: border-box;
`

export const AddButtonDiv = styled(All.Div)`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3%;
`

export const DeleteButtonDiv = styled(All.Div)`
    display: flex;
    align-items: center;
    justify-content: left;
    margin: 2% 0% 1% 0%;
`

export const DeleteApplicationButtonDiv = styled(All.Div)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`

export const AddButton = styled.button`
    padding: 1.1rem 0.5rem;
    font-size: 1.6rem;
    color: white;
    background-color: #4267B2;
    border-radius: 0.7rem;
    border: none;
`

export const DeleteButton = styled.button`
    padding: 0.6rem 0.5rem;
    font-size: 1.6rem;
    color: white;
    background-color: red;
    border-radius: 0.7rem;
    border: none;
`

export const DeleteApplicationButton = styled.button`
    padding: 1rem 1rem;
    font-size: 1.6rem;
    color: red;
    background-color: transparent;
    border-radius: 0.7rem;
    border: none;
    &:hover{
        background-color: #E8E8E8;
    }
`

export const DropDownSection = styled(All.Div)`
    background-color: #F8F9FC;
`
